export const snakkerVerbs = [
  'make a choice',
  'test an assumption',
  'predict an outcome',
  'compare alternatives',
  'receive an immediate reveal or reward',
]

/** The six teaser screens. `screen` is the index of the matching still in the teaser Snak. */
export const journeySteps = [
  { label: 'Hook', detail: 'Two patients. Same approach? Yes / No', screen: 0 },
  { label: 'Reframe', detail: 'Appropriate response, not maximum', screen: 1 },
  { label: 'Mini-simulator', detail: 'Change AMH + weight, see the challenge', screen: 2 },
  { label: 'REKOVELLE reveal', detail: 'An individualized starting dose', screen: 3, highlight: true },
  { label: 'Make it tangible', detail: 'Calculated for the patient. Set on the pen.', screen: 4 },
  { label: 'Proof / CTA', detail: 'Approved evidence, 2–3 points', screen: 5 },
]

export const doseStates = [
  {
    label: 'Too little',
    points: ['Too few follicles may develop', 'Fewer oocytes may be available for retrieval'],
    tint: 'bg-under-tint',
    text: 'text-under',
  },
  {
    label: 'Right response',
    points: ['Adequate ovarian response', 'Balance between efficacy and safety'],
    tint: 'bg-target-tint',
    text: 'text-target',
  },
  {
    label: 'Too much',
    points: ['Excessive ovarian response', 'Higher risk of OHSS and preventive intervention'],
    tint: 'bg-over-tint',
    text: 'text-over',
  },
]

export const formatBlocks = [
  { title: 'Short', body: 'Designed to earn 30–60 seconds of HCP attention.' },
  { title: 'Active', body: 'The HCP chooses, predicts, slides, compares or responds.' },
  { title: 'Rewarding', body: 'Every interaction gives something back: an answer, reveal, comparison or insight.' },
  { title: 'Memorable', body: 'The product benefit becomes something experienced rather than simply stated.' },
  { title: 'Measurable', body: 'Every interaction creates a signal about what the HCP believes, chooses or wants to explore.' },
]

export const learnOutputs = [
  'Current drug preference',
  'Typical starting-dose choice',
  'How dosing changes by patient profile',
  'Where HCPs hesitate or explore',
  'How they respond to the REKOVELLE reveal',
]

/** Illustrative peer-poll distribution for the concept mock — not real data. */
export const peerChoices = [
  { label: '150 IU', share: 29 },
  { label: '187.5 IU', share: 16 },
  { label: '225 IU', share: 34, you: true },
  { label: '300 IU', share: 15 },
  { label: 'Other', share: 6 },
]

export const peerBenefits = ['Curiosity', 'Social comparison', 'Repeat engagement', 'Richer aggregated insight']

export const useCases = ['Email', 'Website', 'QR', 'Congress', 'Symposium', 'Booth', 'F2F', 'IVA', 'Training']

export const useMoments = [
  'a standalone engagement',
  'a conversation opener',
  'a follow-up after a meeting',
  'part of a campaign journey',
  'an interactive congress or symposium moment',
]
